import { RADIAN } from '@/constants/chart.constants';
import { PieLabelRenderProps } from 'recharts';

export default function ChartLabel({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
}: PieLabelRenderProps) {
  const radius = Number(innerRadius) + (Number(outerRadius) - Number(innerRadius)) * 0.65;
  const x = Number(cx) + +radius * Math.cos(-midAngle * RADIAN);
  const y = Number(cy) + +radius * Math.sin(-midAngle * RADIAN);

  if (!percent || percent < 0.0001) return null;

  const percentValue = Number(percent) * 100;
  const displayValue = percentValue < 1 ? percentValue.toFixed(1) : Math.floor(percentValue);

  return percent && percent >= 0.05 ? (
    <text x={String(x)} y={String(y)} fill="white" textAnchor="middle" dominantBaseline="middle">
      {`${displayValue}%`}
    </text>
  ) : null;
}
